// Translations for The Safe House website
// Complete translations for English and Spanish

const translations = {
  // Navigation
  nav: {
    home: { en: 'Home', es: 'Inicio' },
    about: { en: 'About', es: 'Nosotros' },
    programs: { en: 'Programs', es: 'Programas' },
    coffee: { en: 'Coffee', es: 'Café' },
    donate: { en: 'Donate', es: 'Donar' },
    stories: { en: 'Media', es: 'Medios' },
    heroes: { en: 'The Heroes', es: 'Los Héroes' },
    getInvolved: { en: 'Get Involved', es: 'Involúcrate' },
    donateNow: { en: 'Donate Now', es: 'Donar Ahora' },
    menu: { en: 'menu', es: 'menú' },
  },

  // Homepage Hero
  hero: {
    badge: { en: 'Saving Lives in Colombia', es: 'Salvando Vidas en Colombia' },
    rescuingChildren: { en: 'Rescuing Children.', es: 'Rescatando Niños.' },
    rebuildingHope: { en: 'Rebuilding Hope.', es: 'Reconstruyendo Esperanza.' },
    restoringFutures: { en: 'Restoring Futures.', es: 'Restaurando Futuros.' },
    subheadline: {
      en: 'At "The Safe House" Children\'s Rescue Center in Colombia, we stand in the gap for children in the most dangerous communities by providing protection, healing, and opportunity for a completely transformed future.',
      es: 'En "The Safe House" Centro de Rescate Infantil en Colombia, nos interponemos por los niños en las comunidades más peligrosas, brindando protección, sanación y oportunidad para un futuro completamente transformado.'
    },
    traffickingStatement: {
      en: 'Rescuing children from sex trafficking, organ harvesting, and danger.',
      es: 'Rescatando niños del tráfico sexual, tráfico de órganos y el peligro.'
    },
    donateToday: { en: 'Donate Today', es: 'Donar Hoy' },
    seeStories: { en: 'See Their Stories', es: 'Ver Sus Historias' },
  },

  // Fight For Section
  fightFor: {
    title: { en: 'This Is Who We Fight For.', es: 'Por Ellos Luchamos.' },
    titlePart1: { en: 'This Is', es: 'Por Ellos' },
    titlePart2: { en: 'Who We Fight For.', es: 'Luchamos.' },
    subtitle: { en: 'Every face. Every story. Every future worth saving.', es: 'Cada rostro. Cada historia. Cada futuro que vale la pena salvar.' },
  },

  // Children Counter
  counter: {
    number: { en: '100+', es: '100+' },
    childrenRescued: { en: 'Children Rescued & Protected', es: 'Niños Rescatados y Protegidos' },
    everyNumber: { en: 'Every number is a name. Every name is a story. Every story is a life transformed.', es: 'Cada número es un nombre. Cada nombre es una historia. Cada historia es una vida transformada.' },
  },

  // Mission Section
  mission: {
    title: { en: 'Our Mission', es: 'Nuestra Misión' },
    mainStatement: {
      en: "At our Rescue Center, we rescue vulnerable children from danger and instability and provide them with safety, love, structure, food and support.",
      es: "En nuestro Centro de Rescate, rescatamos a niños vulnerables del peligro y la inestabilidad y les brindamos seguridad, amor, estructura, alimento y apoyo."
    },
    restore: { en: 'Restore', es: 'Restaurar' },
    restoreText: { en: 'identity where trauma tried to define them.', es: 'la identidad donde el trauma intentó definirlos.' },
    strengthen: { en: 'Strengthen', es: 'Fortalecer' },
    strengthenText: { en: 'faith where fear once ruled.', es: 'la fe donde antes reinaba el miedo.' },
    equip: { en: 'Equip', es: 'Equipar' },
    equipText: { en: 'through education, mentorship, and daily care.', es: 'a través de educación, mentoría y cuidado diario.' },
    notShortTerm: { en: 'This is not short-term relief.', es: 'Esto no es alivio a corto plazo.' },
    lastingTransformation: { en: 'lasting transformation.', es: 'transformación duradera.' },
    thisIs: { en: 'This is', es: 'Esto es' },
    weAreRebuilding: { en: 'We are rebuilding foundations.', es: 'Estamos reconstruyendo cimientos.' },
    weAreBreaking: { en: 'We are breaking generational cycles.', es: 'Estamos rompiendo ciclos generacionales.' },
    weAreRaising: { en: 'We are raising', es: 'Estamos criando' },
    worldChangers: { en: 'WORLD-CHANGERS.', es: 'TRANSFORMADORES.' },
    closingStatement: {
      en: 'And every child we reach is proof that a new future is possible.',
      es: 'Y cada niño que alcanzamos es prueba de que un nuevo futuro es posible.'
    },
  },

  // World Changers Section
  worldChangers: {
    title: { en: 'We are raising WORLD-CHANGERS', es: 'Estamos criando TRANSFORMADORES' },
    description: {
      en: 'These children are more than survivors — they are future leaders, teachers, doctors, pastors, and change-makers. When you invest in a child at The Safe House, you\'re not just changing one life — you\'re changing generations.',
      es: 'Estos niños son más que sobrevivientes — son futuros líderes, maestros, doctores, pastores y agentes de cambio. Cuando inviertes en un niño en The Safe House, no solo cambias una vida — cambias generaciones.'
    },
  },

  // Hope Section
  hope: {
    title: { en: 'This is what hope looks like.', es: 'Así se ve la esperanza.' },
    subtitle: { en: 'Celebration day at The Safe House', es: 'Día de celebración en The Safe House' },
  },

  // You Are The Hero Section
  youAreHero: {
    badge: { en: 'THANK YOU', es: 'GRACIAS' },
    title: { en: 'You Are The Hero', es: 'Tú Eres El Héroe' },
    subtitle: {
      en: 'Every donation, every prayer, every share — you are the reason these children have hope. Because of you, a child will sleep safely tonight. Because of you, a future is being rewritten.',
      es: 'Cada donación, cada oración, cada compartir — tú eres la razón por la que estos niños tienen esperanza. Gracias a ti, un niño dormirá seguro esta noche. Gracias a ti, un futuro está siendo reescrito.'
    },
    becomeHero: { en: 'Become a Hero Today', es: 'Conviértete en Héroe Hoy' },
  },

  // Coffee Page
  coffee: {
    launchDate: { en: 'Official Launch Date:', es: 'Fecha Oficial de Lanzamiento:' },
    march23: { en: 'May 1st', es: '1 de Mayo' },
    markCalendar: { en: 'MARK YOUR CALENDAR', es: 'MARCA TU CALENDARIO' },
    preorderText: {
      en: 'Be the first to taste & experience Safe House Coffee. Sign up for pre-order and exclusive early access.',
      es: 'Sé el primero en probar y experimentar Safe House Coffee. Regístrate para pre-orden y acceso anticipado exclusivo.'
    },
    notifyMe: { en: 'Notify Me', es: 'Notificarme' },
    submit: { en: 'Submit', es: 'Enviar' },
    onTheList: { en: "You're on the list!", es: '¡Estás en la lista!' },
    notifyWhenReady: { 
      en: "We'll notify you as soon as Safe House Coffee is ready to order.", 
      es: 'Te notificaremos tan pronto como Safe House Coffee esté listo para ordenar.' 
    },
    privacyNote: { en: 'We respect your privacy. Unsubscribe anytime.', es: 'Respetamos tu privacidad. Cancela cuando quieras.' },
    heroTitle: { en: 'Safe House Coffee', es: 'Safe House Coffee' },
    heroSubtitle: { en: 'Premium Coffee with a Powerful Purpose', es: 'Café Premium con un Propósito Poderoso' },
    heroDescription: {
      en: '100% of proceeds go directly to rescuing and protecting children in Colombia',
      es: '100% de las ganancias van directamente a rescatar y proteger niños en Colombia'
    },
    shopNow: { en: 'Shop Now', es: 'Comprar Ahora' },
    ourStory: { en: 'Our Story', es: 'Nuestra Historia' },
    
    // Heritage Section
    singleOrigin: { en: 'Single-Origin Excellence', es: 'Excelencia de Origen Único' },
    singleOriginDesc: {
      en: 'Every smooth sip of our coffee begins in the hands of farmers who grow each bean with care, patience, and purpose. Hand-selected from the best microlots in Colombia.',
      es: 'Cada sorbo suave de nuestro café comienza en las manos de agricultores que cultivan cada grano con cuidado, paciencia y propósito. Seleccionado a mano de los mejores microlotes de Colombia.'
    },
    highAltitude: { en: 'High-Altitude Terroir', es: 'Terroir de Alta Altitud' },
    highAltitudeDesc: {
      en: 'Grown at 1,400-1,800 meters where cool mountain air and rich volcanic soil create unparalleled flavor complexity and sweetness',
      es: 'Cultivado a 1,400-1,800 metros donde el aire fresco de montaña y el suelo volcánico rico crean complejidad y dulzura de sabor incomparables'
    },
    certifiedOrganic: { en: 'Certified Organic', es: 'Certificado Orgánico' },
    certifiedOrganicDesc: {
      en: 'Premium 100% Arabica beans, organically grown without pesticides, hand-selected by local Colombian farmers',
      es: 'Granos premium 100% Arábica, cultivados orgánicamente sin pesticidas, seleccionados a mano por agricultores colombianos locales'
    },
    directTrade: { en: 'Direct Trade', es: 'Comercio Directo' },
    directTradeDesc: {
      en: 'Supporting Colombian farming families with fair wages and sustainable practices that preserve traditional methods',
      es: 'Apoyando a familias agricultoras colombianas con salarios justos y prácticas sostenibles que preservan métodos tradicionales'
    },
    
    // Journey Section
    farmToTable: { en: 'From Colombian Farm to Your Table', es: 'De la Finca Colombiana a Tu Mesa' },
    farmToTableDesc: { en: 'An exclusive journey of organic excellence and artisanal craftsmanship', es: 'Un viaje exclusivo de excelencia orgánica y artesanía artesanal' },
    handPicked: { en: 'Hand-Picked Harvest', es: 'Cosecha Seleccionada a Mano' },
    handPickedDesc: {
      en: 'Only perfectly ripe coffee cherries hand-selected at peak ripeness from organic Colombian farms',
      es: 'Solo cerezas de café perfectamente maduras seleccionadas a mano en su punto máximo de madurez de fincas colombianas orgánicas'
    },
    traditionalProcessing: { en: 'Traditional Processing', es: 'Procesamiento Tradicional' },
    traditionalProcessingDesc: {
      en: 'Wet-processed using pure mountain spring water, preserving the clean, bright flavors of premium beans',
      es: 'Procesado en húmedo usando agua pura de manantial de montaña, preservando los sabores limpios y brillantes de granos premium'
    },
    artisanRoasting: { en: 'Artisan Roasting', es: 'Tostado Artesanal' },
    artisanRoastingDesc: {
      en: "Small-batch roasted to perfection by master roasters who honor each bean's unique character",
      es: 'Tostado en pequeños lotes a la perfección por maestros tostadores que honran el carácter único de cada grano'
    },
    morningRitual: { en: 'Your Morning Ritual', es: 'Tu Ritual Matutino' },
    morningRitualDesc: {
      en: '100% of proceeds support children at The Safe House - every cup creates hope and changes lives',
      es: '100% de las ganancias apoyan a los niños de The Safe House - cada taza crea esperanza y cambia vidas'
    },
    
    // Great for Good Section
    greatForGood: { en: 'Great for Good', es: 'Gran Café para el Bien' },
    everySmooth: {
      en: 'Every smooth sip of our coffee begins in the hands of farmers who grow each bean with care, patience, and purpose.',
      es: 'Cada sorbo suave de nuestro café comienza en las manos de agricultores que cultivan cada grano con cuidado, paciencia y propósito.'
    },
    storyDoesntEnd: { en: "THE STORY DOESN'T END IN YOUR CUP", es: 'LA HISTORIA NO TERMINA EN TU TAZA' },
    compassionMeets: {
      en: 'Because when compassion and innovation meet, marvelous things happen.',
      es: 'Porque cuando la compasión y la innovación se encuentran, cosas maravillosas suceden.'
    },
    everySipFuels: {
      en: "Every sip fuels the work of The Safe House Children's Rescue Center, providing protection, education, and hope to vulnerable children in Colombia's most dangerous communities.",
      es: 'Cada sorbo impulsa el trabajo del Centro de Rescate Infantil The Safe House, brindando protección, educación y esperanza a niños vulnerables en las comunidades más peligrosas de Colombia.'
    },
    enjoyGreat: { en: 'Enjoy Great Coffee for Good.', es: 'Disfruta Gran Café para el Bien.' },
    proceedsRescuing: {
      en: '100% of proceeds go directly to rescuing and protecting children.',
      es: '100% de las ganancias van directamente a rescatar y proteger niños.'
    },
    
    // Products Section
    signatureBlends: { en: 'Our Signature Blends', es: 'Nuestras Mezclas Exclusivas' },
    signatureBlendsDesc: {
      en: 'Two exceptional blends, meticulously roasted for bold flavor and rich aroma.',
      es: 'Dos mezclas excepcionales, meticulosamente tostadas para un sabor audaz y un aroma rico.'
    },
    arabicaProceeds: {
      en: '100% Arabica. 100% of proceeds change lives.',
      es: '100% Arábica. 100% de las ganancias cambian vidas.'
    },
    organic: { en: 'ORGANIC', es: 'ORGÁNICO' },
    roast: { en: 'Roast', es: 'Tueste' },
    singleOriginLabel: { en: 'Single Origin', es: 'Origen Único' },
    tastingNotes: { en: 'Tasting Notes:', es: 'Notas de Cata:' },
    ozBag: { en: '12 oz bag', es: 'bolsa de 340g' },
    addToCart: { en: 'Add to Cart', es: 'Agregar al Carrito' },
    proceedsSupport: { en: '100% proceeds support children', es: '100% de las ganancias apoyan a los niños' },
    
    // Impact Section
    everyCupHope: { en: 'Every Cup Creates Hope', es: 'Cada Taza Crea Esperanza' },
    notPortion: {
      en: 'Not a portion. Not a percentage.',
      es: 'No es una porción. No es un porcentaje.'
    },
    everySingleDollar: { en: 'Every single dollar', es: 'Cada dólar' },
    fromCoffeeSales: {
      en: 'from coffee sales goes directly to feeding, educating, and caring for children at The Safe House.',
      es: 'de las ventas de café va directamente a alimentar, educar y cuidar a los niños de The Safe House.'
    },
    oneBag: { en: '1 Bag', es: '1 Bolsa' },
    oneBagImpact: { en: '= 15 meals for children', es: '= 15 comidas para niños' },
    fiveBags: { en: '5 Bags', es: '5 Bolsas' },
    fiveBagsImpact: { en: '= School supplies for 3 students', es: '= Útiles escolares para 3 estudiantes' },
    tenBags: { en: '10 Bags', es: '10 Bolsas' },
    tenBagsImpact: { en: '= Birthday celebration for a child', es: '= Celebración de cumpleaños para un niño' },
    learnMoreMission: { en: 'Learn More About Our Mission', es: 'Conoce Más Sobre Nuestra Misión' },
    
    // Why Choose Us Section
    whySafeHouse: { en: 'Why Safe House Coffee?', es: '¿Por Qué Safe House Coffee?' },
    qualityGuaranteed: { en: 'Quality Guaranteed', es: 'Calidad Garantizada' },
    qualityGuaranteedDesc: {
      en: 'Premium Colombian Arabica beans, expertly roasted for exceptional flavor',
      es: 'Granos premium Arábica colombianos, expertamente tostados para un sabor excepcional'
    },
    freeShipping: { en: 'Free Shipping', es: 'Envío Gratis' },
    freeShippingDesc: {
      en: 'Complimentary shipping on all orders over $50 within the continental US',
      es: 'Envío gratuito en todos los pedidos mayores a $50 dentro de Estados Unidos continental'
    },
    hundredImpact: { en: '100% Impact', es: '100% Impacto' },
    hundredImpactDesc: {
      en: 'Every single cent of profit goes directly to children in need',
      es: 'Cada centavo de ganancia va directamente a los niños necesitados'
    },
    
    // Final CTA Section
    elevateYour: { en: 'Elevate Your Morning. Transform a Life.', es: 'Eleva Tu Mañana. Transforma una Vida.' },
    experienceExclusive: {
      en: 'Experience the exclusive taste of organic Colombian coffee while making an extraordinary impact.',
      es: 'Experimenta el sabor exclusivo del café orgánico colombiano mientras haces un impacto extraordinario.'
    },
    everyBagConnection: {
      en: 'Every bag is a direct connection from Colombian farm families to rescued children.',
      es: 'Cada bolsa es una conexión directa de las familias agricultoras colombianas a los niños rescatados.'
    },
    orderPremium: { en: 'Order Premium Coffee', es: 'Ordenar Café Premium' },
  },

  // Donate Page
  donate: {
    heroTitle: { en: 'Change a Life Today', es: 'Cambia una Vida Hoy' },
    heroSubtitle: { 
      en: 'Your gift provides safety, education, and hope to children who have none.',
      es: 'Tu donación proporciona seguridad, educación y esperanza a niños que no tienen nada.'
    },
    heroLine1: { en: 'A child in Colombia needs safety, nourishment, and hope.', es: 'Un niño en Colombia necesita seguridad, alimento y esperanza.' },
    heroLine2: { en: 'Your generosity makes rescue possible.', es: 'Tu generosidad hace posible el rescate.' },
    becomeMonthly: { en: 'Become a Monthly Sponsor', es: 'Conviértete en Patrocinador Mensual' },
    giveOnce: { en: 'Give Once', es: 'Donar Una Vez' },
    everyDollar: { en: 'Every dollar you give becomes a meal, a safe night, a moment of hope for a child who has nothing', es: 'Cada dólar que das se convierte en una comida, una noche segura, un momento de esperanza para un niño que no tiene nada' },
    quoteInspirational: { en: "A person's actions has the potential to rewrite a child's story,", es: 'Las acciones de una persona tienen el potencial de reescribir la historia de un niño,' },
    quoteTriumphs: { en: 'transforming challenges into triumphs.', es: 'transformando desafíos en triunfos.' },
    childFuture: { en: "A child's future can change", es: 'El futuro de un niño puede cambiar' },
    today: { en: 'today.', es: 'hoy.' },
    beHero: { en: 'Be a hero and sponsor a child.', es: 'Sé un héroe y patrocina a un niño.' },
    chooseImpact: { en: 'Choose your impact.', es: 'Elige tu impacto.' },
    beReason: { en: 'Be the reason hope rises.', es: 'Sé la razón por la que la esperanza se levanta.' },
    oneTime: { en: 'One-Time Gift', es: 'Donación Única' },
    monthly: { en: 'Monthly Partner', es: 'Socio Mensual' },
    monthlyPartnership: { en: 'Monthly Partnership', es: 'Sociedad Mensual' },
    recommended: { en: 'Recommended', es: 'Recomendado' },
    monthlyBadge: { en: 'Monthly partners provide', es: 'Los socios mensuales proporcionan' },
    monthlyBadge2: { en: 'consistent, life-changing support', es: 'apoyo constante que cambia vidas' },
    monthlyBadge3: { en: 'that children can depend on.', es: 'con el que los niños pueden contar.' },
    popular: { en: 'POPULAR', es: 'POPULAR' },
    coversOneMonth: { en: '* Covers one full month', es: '* Cubre un mes completo' },
    customAmount: { en: 'Custom Amount — Follow Your Calling', es: 'Cantidad Personalizada — Sigue Tu Llamado' },
    enterAmount: { en: 'Enter amount', es: 'Ingresa cantidad' },
    perMonth: { en: '/month', es: '/mes' },
    giveNow: { en: 'Give Now', es: 'Donar Ahora' },
    secureRedirect: { en: "You'll be securely redirected to our Tithe.ly giving portal", es: 'Serás redirigido de forma segura a nuestro portal de donaciones Tithe.ly' },
    legacyTitle: { en: 'Become a Legacy Partner', es: 'Conviértete en Socio de Legado' },
    legacyIntro1: { en: 'Some people give.', es: 'Algunas personas dan.' },
    legacyIntro2: { en: 'Others help build the future.', es: 'Otros ayudan a construir el futuro.' },
    legacyIntro3: { en: 'Legacy Partners are the leaders who step forward to make the greatest impact — helping rescue vulnerable children and create the safe environments where restoration and transformation can begin.', es: 'Los Socios de Legado son los líderes que dan un paso adelante para generar el mayor impacto — ayudando a rescatar niños vulnerables y crear los ambientes seguros donde la restauración y la transformación pueden comenzar.' },
    legacyIntro4: { en: 'Your generosity today does more than meet immediate needs.', es: 'Tu generosidad hoy hace más que satisfacer necesidades inmediatas.' },
    legacyIntro5: { en: 'It helps build a future where more children can be', es: 'Ayuda a construir un futuro donde más niños puedan ser' },
    legacyIntro6: { en: 'protected, restored, educated, and equipped to lead.', es: 'protegidos, restaurados, educados y equipados para liderar.' },
    legacyIntro7: { en: 'Together, we are building something that will impact generations.', es: 'Juntos, estamos construyendo algo que impactará generaciones.' },
    hopeBuilder: { en: 'Hope Builder', es: 'Constructor de Esperanza' },
    hopeBuilderDesc: { en: 'Provide critical care and stability for vulnerable children.', es: 'Proporcionar cuidado crítico y estabilidad para niños vulnerables.' },
    hopeBuilderText: { en: 'Your gift helps provide meals, safe care, educational support, mentorship, and the daily resources children need to grow in a safe and loving environment.', es: 'Tu donación ayuda a proporcionar comidas, cuidado seguro, apoyo educativo, mentoría y los recursos diarios que los niños necesitan para crecer en un ambiente seguro y amoroso.' },
    freedomChampion: { en: 'Freedom Champion', es: 'Campeón de la Libertad' },
    freedomChampionDesc: { en: 'Provide essential supplies and necessities for the children.', es: 'Provee suministros esenciales y necesidades para los niños.' },
    freedomChampionText: { en: 'Your gift directly provides shoes, clothing, backpacks, school supplies, and everyday necessities that our children need. These essentials give them dignity, confidence, and the tools to thrive in their education and daily lives.', es: 'Tu donación provee directamente zapatos, ropa, mochilas, útiles escolares y necesidades diarias que nuestros niños necesitan. Estos elementos esenciales les dan dignidad, confianza y las herramientas para prosperar en su educación y vida diaria.' },
    restorationLeader: { en: 'Restoration Leader', es: 'Líder de Restauración' },
    restorationLeaderDesc: { en: 'Fund critical equipment and supplies for the rescue center.', es: 'Financia equipos y suministros críticos para el centro de rescate.' },
    restorationLeaderText: { en: 'Your generous support helps purchase essential large items the rescue center needs — from air conditioning units to keep the children comfortable, to kitchen supplies for preparing daily meals, and computers for their education. These bigger investments transform the quality of life at The Safe House.', es: 'Tu generoso apoyo ayuda a comprar artículos esenciales que el centro de rescate necesita — desde unidades de aire acondicionado para mantener cómodos a los niños, hasta suministros de cocina para preparar comidas diarias y computadoras para su educación. Estas inversiones mayores transforman la calidad de vida en The Safe House.' },
    visionBuilder: { en: 'Vision Builder', es: 'Constructor de Visión' },
    visionBuilderDesc: { en: 'Help build and expand the rescue center facilities.', es: 'Ayuda a construir y expandir las instalaciones del centro de rescate.' },
    visionBuilderText: { en: 'This leadership gift directly funds building projects and facility expansion — including constructing a new kitchen, expanding living spaces, and creating new areas where more children can be rescued, protected, and restored. Your investment builds the physical foundation for a growing mission.', es: 'Este regalo de liderazgo financia directamente proyectos de construcción y expansión — incluyendo la construcción de una nueva cocina, ampliación de espacios de vivienda y creación de nuevas áreas donde más niños pueden ser rescatados, protegidos y restaurados. Tu inversión construye la base física para una misión en crecimiento.' },
    visionBuilderText2: { en: 'Your generosity helps lay the foundation for a facility that will impact children for generations to come.', es: 'Tu generosidad ayuda a sentar las bases para unas instalaciones que impactarán a los niños por generaciones.' },
    foundingBuilder: { en: 'Founding Builder', es: 'Constructor Fundador' },
    foundingBuilderBadge: { en: 'FOUNDING BUILDER', es: 'CONSTRUCTOR FUNDADOR' },
    foundingBuilderDesc: { en: 'Help build a legacy that will impact generations.', es: 'Ayuda a construir un legado que impactará generaciones.' },
    foundingBuilderText: { en: "Founding Builders play a vital role in expanding The Safe House Children's Rescue Center — helping fund construction on more safe houses for the children and creating new spaces of safety, restoration, and opportunity for vulnerable children who need it most.", es: 'Los Constructores Fundadores juegan un papel vital en la expansión del Centro de Rescate Infantil The Safe House — ayudando a financiar la construcción de más casas seguras para los niños y creando nuevos espacios de seguridad, restauración y oportunidad para los niños vulnerables que más lo necesitan.' },
    foundingBuilderWall: { en: 'your name will be permanently engraved on the Legacy Wall', es: 'tu nombre será grabado permanentemente en el Muro de Legado' },
    foundingBuilderWallText: { en: "As a lasting recognition of your generosity,", es: 'Como reconocimiento duradero de tu generosidad,' },
    foundingBuilderWallText2: { en: "inside the Safe House facility, honoring your role in helping build a place where children's lives are rescued, restored, and transformed.", es: 'dentro de las instalaciones de Safe House, honrando tu papel en ayudar a construir un lugar donde las vidas de los niños son rescatadas, restauradas y transformadas.' },
    foundingBuilderYears: { en: 'Years from now, children who grow up in safety and hope will walk past the Legacy Wall and see the names of those who made their future possible. Your generosity will not only change lives today —', es: 'Años después, los niños que crezcan en seguridad y esperanza pasarán frente al Muro de Legado y verán los nombres de quienes hicieron posible su futuro. Tu generosidad no solo cambiará vidas hoy —' },
    foundingBuilderRemembered: { en: 'it will be remembered for generations.', es: 'será recordada por generaciones.' },
    becomeFoundingBuilder: { en: 'Become a Founding Builder', es: 'Conviértete en Constructor Fundador' },
    legacyCTA1: { en: 'The difference between fear and safety is someone choosing to act.', es: 'La diferencia entre el miedo y la seguridad es que alguien elige actuar.' },
    legacyCTA2: { en: 'Today, that someone can be you.', es: 'Hoy, ese alguien puedes ser tú.' },
    legacyCTA3: { en: 'Become a Legacy Partner and help rescue children, restore lives, and build a future filled with hope.', es: 'Conviértete en Socio de Legado y ayuda a rescatar niños, restaurar vidas y construir un futuro lleno de esperanza.' },
    socialProofTitle: { en: 'Because Someone Chose to', es: 'Porque Alguien Eligió' },
    socialProofCare: { en: 'Care.', es: 'Importarle.' },
    testimonialQuote: { en: '"When I saw the impact my monthly gift was making, I knew this was exactly where God wanted my resources. These children are being transformed."', es: '"Cuando vi el impacto que estaba haciendo mi donación mensual, supe que este era exactamente donde Dios quería mis recursos. Estos niños están siendo transformados."' },
    testimonialName: { en: 'Sarah M.', es: 'Sarah M.' },
    testimonialSince: { en: 'Monthly Partner since 2023', es: 'Socia Mensual desde 2023' },
    childQuote: { en: '"Before The Safe House, I didn\'t know if tomorrow would come. Now I have a family, I\'m learning, and I dream of becoming a teacher."', es: '"Antes de The Safe House, no sabía si el mañana llegaría. Ahora tengo una familia, estoy aprendiendo y sueño con ser maestra."' },
    childName: { en: 'Maria, Age 11', es: 'María, 11 años' },
    childStatus: { en: 'Rescued & Restored', es: 'Rescatada y Restaurada' },
    finalLine1: { en: 'Right now, children are facing hunger, abuse, and dangerous environments.', es: 'En este momento, niños enfrentan hambre, abuso y ambientes peligrosos.' },
    finalLine2: { en: 'We cannot wait.', es: 'No podemos esperar.' },
    finalLine3: { en: 'And neither can they.', es: 'Y ellos tampoco.' },
    finalLine4: { en: 'Your gift today becomes food, protection, education, and the life-changing love of God.', es: 'Tu donación hoy se convierte en alimento, protección, educación y el amor transformador de Dios.' },
    giveWithConfidence: { en: 'Give With Confidence', es: 'Dona Con Confianza' },
    irsRecognized: { en: 'We are an IRS Recognized', es: 'Somos una organización reconocida por el IRS' },
    taxExempt: { en: '501(c)(3) Tax-Exempt Charitable Organization.', es: '501(c)(3) Organización Benéfica Exenta de Impuestos.' },
    taxDeductible: { en: 'All donations are tax-deductible as allowed by law.', es: 'Todas las donaciones son deducibles de impuestos según lo permita la ley.' },
    hundredPercent: { en: '100% of your donation goes directly to protecting and caring for these children.', es: '100% de tu donación va directamente a proteger y cuidar a estos niños.' },
    questions: { en: 'Questions? Contact us at', es: '¿Preguntas? Contáctanos en' },
  },

  // Stories Page
  stories: {
    heroTitle: { en: 'Stories of Transformation', es: 'Historias de Transformación' },
    heroSubtitle: { 
      en: 'Real stories of hope, healing, and new beginnings',
      es: 'Historias reales de esperanza, sanación y nuevos comienzos'
    },
    watchNow: { en: 'Watch Now', es: 'Ver Ahora' },
    featuredStories: { en: 'Featured Stories', es: 'Historias Destacadas' },
    allStories: { en: 'All Stories', es: 'Todas las Historias' },
    categories: { en: 'Categories', es: 'Categorías' },
    videos: { en: 'videos', es: 'videos' },
    impactMessage: {
      en: 'Every video you watch represents a life transformed. Your support makes these stories possible.',
      es: 'Cada video que ves representa una vida transformada. Tu apoyo hace posibles estas historias.'
    },
    supportMission: { en: 'Support Our Mission', es: 'Apoya Nuestra Misión' },
  },

  // About Page
  about: {
    heroTitle: { en: 'Our Story', es: 'Nuestra Historia' },
    heroSubtitle: { 
      en: 'A journey of faith, love, and transformation',
      es: 'Un viaje de fe, amor y transformación'
    },
    missionTitle: { en: 'Our Mission', es: 'Nuestra Misión' },
    missionText: {
      en: 'To rescue, restore, and equip vulnerable children in Colombia, providing them with safety, education, and the foundation for a transformed future.',
      es: 'Rescatar, restaurar y equipar a niños vulnerables en Colombia, brindándoles seguridad, educación y la base para un futuro transformado.'
    },
    visionTitle: { en: 'Our Vision', es: 'Nuestra Visión' },
    visionText: {
      en: 'A Colombia where every child is safe, loved, and empowered to become a world-changer.',
      es: 'Una Colombia donde cada niño esté seguro, amado y capacitado para convertirse en un agente de cambio.'
    },
    valuesTitle: { en: 'Our Values', es: 'Nuestros Valores' },
    valueFaith: { en: 'Faith', es: 'Fe' },
    valueFaithText: { en: 'Grounded in our belief that every child is created with purpose', es: 'Fundamentados en nuestra creencia de que cada niño fue creado con propósito' },
    valueLove: { en: 'Love', es: 'Amor' },
    valueLoveText: { en: 'Unconditional care for every child in our home', es: 'Cuidado incondicional para cada niño en nuestro hogar' },
    valueExcellence: { en: 'Excellence', es: 'Excelencia' },
    valueExcellenceText: { en: 'Committed to the highest standards in everything we do', es: 'Comprometidos con los más altos estándares en todo lo que hacemos' },
    valueIntegrity: { en: 'Integrity', es: 'Integridad' },
    valueIntegrityText: { en: 'Transparent and accountable in all our actions', es: 'Transparentes y responsables en todas nuestras acciones' },
    teamTitle: { en: 'Our Team', es: 'Nuestro Equipo' },
    founder: { en: 'Founder & Director', es: 'Fundador y Director' },
    timelineTitle: { en: 'Our Journey', es: 'Nuestro Camino' },
    timeline2018: { en: 'The vision for The Safe House was born', es: 'Nació la visión de The Safe House' },
    timeline2019: { en: 'First children welcomed into our care', es: 'Primeros niños recibidos en nuestro cuidado' },
    timeline2020: { en: 'Expanded programs and facilities', es: 'Programas e instalaciones expandidos' },
    timeline2021: { en: 'Launched education initiative', es: 'Lanzamiento de iniciativa educativa' },
    timeline2022: { en: 'Opened second location', es: 'Apertura de segunda ubicación' },
    timeline2023: { en: 'Reached 100+ children served', es: 'Alcanzamos 100+ niños atendidos' },
  },

  // Programs Page
  programs: {
    heroTitle: { en: 'Our Programs', es: 'Nuestros Programas' },
    heroSubtitle: { 
      en: 'Comprehensive care for every child',
      es: 'Cuidado integral para cada niño'
    },
    rescueTitle: { en: 'Rescue & Protection', es: 'Rescate y Protección' },
    rescueText: {
      en: 'We work with local authorities to identify and rescue children from dangerous situations, providing immediate safety and care.',
      es: 'Trabajamos con autoridades locales para identificar y rescatar niños de situaciones peligrosas, brindando seguridad y cuidado inmediato.'
    },
    housingTitle: { en: 'Safe Housing', es: 'Vivienda Segura' },
    housingText: {
      en: 'Our home provides a loving, family environment where children can heal and grow in safety.',
      es: 'Nuestro hogar proporciona un ambiente amoroso y familiar donde los niños pueden sanar y crecer con seguridad.'
    },
    educationTitle: { en: 'Education', es: 'Educación' },
    educationText: {
      en: 'Every child receives quality education, tutoring, and support to reach their full academic potential.',
      es: 'Cada niño recibe educación de calidad, tutoría y apoyo para alcanzar su máximo potencial académico.'
    },
    healthTitle: { en: 'Health & Wellness', es: 'Salud y Bienestar' },
    healthText: {
      en: 'Comprehensive healthcare including medical, dental, and mental health services for every child.',
      es: 'Atención médica integral incluyendo servicios médicos, dentales y de salud mental para cada niño.'
    },
    spiritualTitle: { en: 'Spiritual Development', es: 'Desarrollo Espiritual' },
    spiritualText: {
      en: 'Faith-based programs that help children discover their identity and purpose.',
      es: 'Programas basados en la fe que ayudan a los niños a descubrir su identidad y propósito.'
    },
    lifeSkillsTitle: { en: 'Life Skills', es: 'Habilidades para la Vida' },
    lifeSkillsText: {
      en: 'Practical training and mentorship to prepare children for independent, successful futures.',
      es: 'Capacitación práctica y mentoría para preparar a los niños para futuros independientes y exitosos.'
    },
    learnMore: { en: 'Learn More', es: 'Saber Más' },
    supportPrograms: { en: 'Support Our Programs', es: 'Apoya Nuestros Programas' },
  },

  // Get Involved Page
  getInvolved: {
    heroTitle: { en: 'Get Involved', es: 'Involúcrate' },
    heroSubtitle: { 
      en: 'Join us in transforming lives',
      es: 'Únete a nosotros en transformar vidas'
    },
    donateTitle: { en: 'Donate', es: 'Donar' },
    donateText: {
      en: 'Your financial gift directly impacts the lives of children in our care.',
      es: 'Tu donación impacta directamente las vidas de los niños bajo nuestro cuidado.'
    },
    donateButton: { en: 'Give Now', es: 'Donar Ahora' },
    sponsorTitle: { en: 'Sponsor a Child', es: 'Patrocina un Niño' },
    sponsorText: {
      en: 'Build a personal connection with a child and provide ongoing support for their journey.',
      es: 'Construye una conexión personal con un niño y brinda apoyo continuo para su camino.'
    },
    sponsorButton: { en: 'Learn More', es: 'Saber Más' },
    prayTitle: { en: 'Pray', es: 'Orar' },
    prayText: {
      en: 'Join our prayer team and lift up the children and staff in your daily prayers.',
      es: 'Únete a nuestro equipo de oración y eleva a los niños y al personal en tus oraciones diarias.'
    },
    prayButton: { en: 'Prayer Requests', es: 'Peticiones de Oración' },
    volunteerTitle: { en: 'Volunteer', es: 'Voluntariado' },
    volunteerText: {
      en: 'Use your skills and time to make a difference, whether locally or on a mission trip.',
      es: 'Usa tus habilidades y tiempo para hacer la diferencia, ya sea localmente o en un viaje misionero.'
    },
    volunteerButton: { en: 'Apply Now', es: 'Aplicar Ahora' },
    spreadWordTitle: { en: 'Spread the Word', es: 'Corre la Voz' },
    spreadWordText: {
      en: 'Share our mission with your friends, family, and community to help us reach more supporters.',
      es: 'Comparte nuestra misión con tus amigos, familia y comunidad para ayudarnos a alcanzar más colaboradores.'
    },
    spreadWordButton: { en: 'Share Now', es: 'Compartir Ahora' },
    corporateTitle: { en: 'Corporate Partnership', es: 'Alianza Corporativa' },
    corporateText: {
      en: 'Partner with us as a business to create lasting impact and engage your employees in meaningful giving.',
      es: 'Asóciate con nosotros como empresa para crear impacto duradero e involucrar a tus empleados en donaciones significativas.'
    },
    corporateButton: { en: 'Partner With Us', es: 'Asóciate Con Nosotros' },
    contactTitle: { en: 'Contact Us', es: 'Contáctanos' },
    contactText: {
      en: 'Have questions or want to learn more? We\'d love to hear from you.',
      es: '¿Tienes preguntas o quieres saber más? Nos encantaría saber de ti.'
    },
    contactButton: { en: 'Get in Touch', es: 'Contáctanos' },
  },

  // Footer
  footer: {
    tagline: { 
      en: 'Rescuing, Restoring, and Equipping the most vulnerable children in Colombia.',
      es: 'Rescatando, Restaurando y Equipando a los niños más vulnerables de Colombia.'
    },
    quickLinks: { en: 'Quick Links', es: 'Enlaces Rápidos' },
    contact: { en: 'Contact', es: 'Contacto' },
    newsletter: { en: 'Newsletter', es: 'Boletín' },
    newsletterText: { 
      en: 'Stay updated on our mission and the children we serve.',
      es: 'Mantente actualizado sobre nuestra misión y los niños que servimos.'
    },
    subscribe: { en: 'Subscribe', es: 'Suscribirse' },
    allRightsReserved: { en: 'All rights reserved.', es: 'Todos los derechos reservados.' },
    nonprofit: { en: '501(c)(3) Nonprofit Organization', es: 'Organización sin fines de lucro 501(c)(3)' },
    privacyPolicy: { en: 'Privacy Policy', es: 'Política de Privacidad' },
    termsOfService: { en: 'Terms of Service', es: 'Términos de Servicio' },
  },

  // Email Popup
  popup: {
    title: { en: 'Stay Connected', es: 'Mantente Conectado' },
    subtitle: { 
      en: 'Get updates on rescued children and ways you can help.',
      es: 'Recibe actualizaciones sobre niños rescatados y cómo puedes ayudar.'
    },
    subscribeNow: { en: 'Subscribe Now', es: 'Suscribirse Ahora' },
    subscribing: { en: 'Subscribing...', es: 'Suscribiendo...' },
    thankYou: { en: 'Thank you for subscribing!', es: '¡Gracias por suscribirte!' },
    successMessage: { en: 'We\'ll keep you updated on our mission.', es: 'Te mantendremos actualizado sobre nuestra misión.' },
  },

  // Common / Shared
  common: {
    learnMore: { en: 'Learn More', es: 'Saber Más' },
    readMore: { en: 'Read More', es: 'Leer Más' },
    watchVideo: { en: 'Watch Video', es: 'Ver Video' },
    close: { en: 'Close', es: 'Cerrar' },
    loading: { en: 'Loading...', es: 'Cargando...' },
    email: { en: 'Email', es: 'Correo electrónico' },
    emailPlaceholder: { en: 'Enter your email', es: 'Ingresa tu correo' },
    phone: { en: 'Phone', es: 'Teléfono' },
    phonePlaceholder: { en: 'Phone number', es: 'Número de teléfono' },
    name: { en: 'Name', es: 'Nombre' },
    message: { en: 'Message', es: 'Mensaje' },
    send: { en: 'Send', es: 'Enviar' },
    submitting: { en: 'Submitting...', es: 'Enviando...' },
    success: { en: 'Success!', es: '¡Éxito!' },
    error: { en: 'Error', es: 'Error' },
    tryAgain: { en: 'Try Again', es: 'Intentar de Nuevo' },
  },

  // Video Modal
  video: {
    loading: { en: 'Loading video...', es: 'Cargando video...' },
    processing: { en: 'Video is processing. Please try again later.', es: 'El video se está procesando. Por favor intenta más tarde.' },
    error: { en: 'Unable to load video.', es: 'No se puede cargar el video.' },
  },

  // Media Page
  media: {
    badge: { en: 'The Safe House', es: 'The Safe House' },
    title: { en: 'Media', es: 'Medios' },
    subtitle: { en: 'Watch the stories, moments, and miracles happening every day.', es: 'Mira las historias, momentos y milagros que suceden cada día.' },
    backToCollections: { en: 'Back to Collections', es: 'Volver a Colecciones' },
    noVideos: { en: 'No videos in this collection yet.', es: 'No hay videos en esta colección aún.' },
    nowPlaying: { en: 'NOW PLAYING', es: 'REPRODUCIENDO' },
    playing: { en: 'PLAYING', es: 'REPRODUCIENDO' },
    videoUnavailable: { en: 'Video unavailable', es: 'Video no disponible' },
    videos: { en: 'videos', es: 'videos' },
    video: { en: 'video', es: 'video' },
  },

  // Donate Payment Modal
  payment: {
    chooseHow: { en: 'Choose How to Give', es: 'Elige Cómo Donar' },
    creditCard: { en: 'Credit / Debit Card', es: 'Tarjeta de Crédito / Débito' },
    securePayment: { en: 'Secure payment processing', es: 'Procesamiento de pago seguro' },
    directBank: { en: 'Direct bank transfer', es: 'Transferencia bancaria directa' },
    payWithVenmo: { en: 'Pay with your Venmo account', es: 'Paga con tu cuenta de Venmo' },
    allSecure: { en: 'All donations are secure and tax-deductible', es: 'Todas las donaciones son seguras y deducibles de impuestos' },
    month: { en: '/month', es: '/mes' },
  },
};

// Helper function to get translation
export const t = (key, language = 'en') => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      console.warn(`Translation not found for key: ${key}`);
      return key;
    }
  }
  
  if (typeof value === 'object' && value[language]) {
    return value[language];
  }
  
  return key;
};

export default translations;
